import React from "react";
import { useSelector } from "react-redux";

import ReportNoteButtons from "./ReportNoteButtons";
import NoteSaveHint from "../NoteSaveHint";
import { ProcessButton } from "./FooterButton";
import useNoteSaveHandlers from "../../hooks/useNoteSaveHandlers";
import { isConnectivityReport } from "utils/footerView.util";

const ClinicActiveButtons = ({ handleProcess }) => {
  const notes = useNoteSaveHandlers();

  const {
    reportDetail,
    hasReportNoteEditAccess,
    clinicNoteSubmittingAndProcessing,
  } = useSelector((state) => state.transmission);

  if (isConnectivityReport(reportDetail)) {
    return <ProcessButton onClick={() => handleProcess("process")} />;
  }

  if (hasReportNoteEditAccess) {
    return (
      <>
        <ReportNoteButtons handleProcess={handleProcess} />

        <NoteSaveHint>
          Archiving or processing this report will also save the Report Note.
        </NoteSaveHint>
      </>
    );
  }

  return (
    <ProcessButton
      onClick={() =>
        notes.saveAndProcessClinicNote() || handleProcess("process")
      }
      isLoading={clinicNoteSubmittingAndProcessing}
    />
  );
};

export default ClinicActiveButtons;
